import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid, TextField, Button, Box, Typography, FormControl, FormHelperText, Checkbox, FormControlLabel
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/pt-br';

import { transformaTextoCamelCase, resizeImage } from '../util';

moment.locale('pt-br');

const FormularioDocumentos = forwardRef((props, ref) => {

  const [campos, setCampos] = useState([
    { id: 6, nome: 'Representante legal' }
   ,{ id: 13, nome: 'Contrato social da empresa' }
   ,{ id: 14, nome: 'Inscrição e situação cadastral' }
   ,{ id: 15, nome: 'Cartão CNPJ' }    
 ]);
  const extensoessAceitas = ['PNG', 'JPEG', 'JPG', 'DOC', 'DOCX', 'PDF'];
  const tamanhoMaximoArquivo = 4 * 1000 * 1024; // Unidade em MB 

  const [formData, setFormData] = useState(props.formData);
  const [validacao, setValidacao] = useState([]);
  const [checks, setChecks] = useState({
    declaracaoUm: false,
    declaracaoDois: false,
    declaracaoTres: false,
  });

  useEffect(() => {
    atualizaValidacao();
  }, [campos]);

  useEffect(() => {
    props.onChildDataChange(formData);
    validaForm();
  }, [formData]);

  useEffect(() => {

    const novosCampos = {
      comprovanteBancario: [{ id: 16, nome: 'Comprovante Bancário' }]
    };

    setCampos([...campos, ...(props.comprovanteBancario ? novosCampos.comprovanteBancario : [])]);

    if (props.formData) {
      validaForm();
    }
    else {
      atualizaValidacao();
    }
  }, []);

  const atualizaValidacao = () => {
    campos.forEach(campo => {
      setValidacao((prev) => ({
        ...prev,
        [objNome(campo.nome)]: false,
      }));
    });
  }

  const validaForm = () => {
    const propriedades = Object.keys(validacao);
    const novaValidacao = { ...validacao };

    propriedades.forEach(propriedade => {
      if (formData) {
        novaValidacao[propriedade] = (formData && formData[propriedade]) ? validaArquivo(formData[propriedade].obj[0]) : false;
      }
    });
    setValidacao(novaValidacao);
  }

  const validaArquivo = (file) => {
    try {
      if (!file) return false;
      const nome = file.name;
      const size = file.size;
      if (!file.size || !file.name) return false;
      const partes = nome.split('.');
      const extensao = partes[partes.length - 1];
      return extensoessAceitas.some(t => t.toLowerCase() == extensao.toLowerCase()) && tamanhoMaximoArquivo >= size;
    } catch (error) {
      console.error(error, 'Erro validação arquivo');
      return false;
    }
  }

  const handleFileChange = async (event, id) => {
      const { name, files } = event.target;
  
      if (files && files[0]) {
        let file = files[0];
        if (file.size > tamanhoMaximoArquivo && file.type.startsWith('image/')) {
          try {
            file = await resizeImage(file, tamanhoMaximoArquivo);
          } catch (error) {
            console.error("Erro ao redimensionar imagem", error);
          }
        }
        else if (file.size > tamanhoMaximoArquivo) {
          alert(`O documento anexado é maior que o permitido, ${(tamanhoMaximoArquivo / 1024) / 1000}}MB`)
        }
        setFormData((prevFiles) => ({
          ...prevFiles,
          [name]: { obj: [file], id: id, nmOriginal: file.name },
        }));
      }
    };

  const handleCheck = (event) => {
    const { name, value, type, checked } = event.target;
    setChecks({
      ...checks,
      [name]: type === 'checkbox' ? checked : value,
    });
  }

  const objNome = (nome) => {
    return transformaTextoCamelCase(nome);
  }

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value) || Object.values(checks).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  // const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%', 'position': 'relative' };

  return (
    <>
      {/* <div style={cssQuebraPagina}></div> */}
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <form>
          <Grid container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap' }}>

            {campos.map((label, index) => (
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth
                  required
                  error={!formData?.impressao && !validacao[objNome(label.nome)]}>
                  <Button
                    key={objNome(label.nome)}
                    variant="contained"
                    component="label"
                    fullWidth
                    sx={{ mt: 2 }}
                    style={{ 'textAlign': 'center' }}
                  >
                    {label.nome}
                    <input
                      type="file"
                      name={objNome(label.nome)}
                      hidden
                      accept={extensoessAceitas.map(t => `.${t.toLowerCase()},`)}
                      onChange={(e) => handleFileChange(e, label.id)}
                    />
                  </Button>
                  <FormHelperText>
                    {(formData && formData[objNome(label.nome)]?.nmOriginal) ? formData[objNome(label.nome)]?.nmOriginal : (formData && formData[objNome(label.nome)] ? formData[objNome(label.nome)].obj[0].name : 'Nenhum arquivo escolhido')}
                  </FormHelperText>
                </FormControl>
              </Grid>
            ))}

            <Grid item>
              <Box mt={2}>
                <Typography variant="body2" color="textSecondary">
                  Tamanho máximo do arquivo: {(tamanhoMaximoArquivo / 1024) / 1000}MB. Formatos aceitos: {extensoessAceitas.join(', ')}.
                </Typography>
              </Box>
            </Grid>

            <Grid item spacing={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData?.impressao || checks?.declaracaoUm || props.finalizado}
                    onChange={handleCheck}
                    name="declaracaoUm"
                  />
                }
                label={<span style={{ color: !checks.declaracaoUm && !props.finalizado ? '#d32f2f' : '' }}>
                  Na forma dos Arts. 97 e 98 da Lei nº 9.610/98, venho solicitar meu ingresso no QUADRO SOCIAL da UNIÃO BRASILEIRA DE COMPOSITORES ahsbdhasbdkjabsjkd,
                  na categoria de efetivo, declarando, neste ato, que tenho conhecimento do <a href='https://www.ubc.org.br/a-ubc/estatuto' target='_blank'>Estatuto</a> e do <a href='https://www.ubc.org.br/a-ubc/organizacao/organograma-e-regime-interno' target='_blank'>
                    Regimento Interno da associação
                  </a>
                  , em especial ao § 5º do Art. 5º e ao § único do Art. 9º, comprometendo-me a respeitá-las.
                </span>}
              />
            </Grid>

            <Grid item spacing={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData?.impressao || checks?.declaracaoDois || props.finalizado}
                    onChange={handleCheck}
                    name="declaracaoDois"
                  />
                }
                label={<span style={{ color: !checks?.declaracaoDois && !props.finalizado ? '#d32f2f' : '' }}>
                  Li e concordo com a <a href='https://www.ubc.org.br/a-ubc/nossas-politicas/politica-de-privacidade' target='_blank'>
                    política de privacidade
                  </a> e o <a href='https://www.ubc.org.br/a-ubc/nossas-politicas/termos-de-uso' target='_blank'>
                    termo de uso
                  </a>.
                </span>}
              />
            </Grid>

            <Grid item spacing={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData?.impressao || checks?.declaracaoTres || props.finalizado}
                    onChange={handleCheck}
                    name="declaracaoTres"
                  />
                }
                label={<span style={{ color: !checks.declaracaoTres && !props.finalizado ? '#d32f2f' : '' }}>
                  <b>Do Uso e Armazenamento dos Dados:</b> Li e concordo expressamente com o tratamento de meus dados pessoais pela <b>UBC</b>, nos termos da Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 - LGPD), compreendendo o uso, coleta, armazenamento, processamento, compartilhamento, atualização e eliminação, sempre em conformidade com as finalidades <b>descritas nos termos de privacidade e consentimento</b>.
                </span>}
              />
            </Grid>

            {props.finalizado &&
              <Grid item xs={12}>Rio de Janeiro, {moment(new Date()).format('DD [de] MMMM [de] YYYY')}</Grid>
            }

          </Grid>
        </form>
      </Box>
    </>
  );
});

export default FormularioDocumentos;
